// Translations
import accessKeyDeletionDialog from '../components/access-key-deletion-dialog/translations/tr'

// Translation: Account > Integrations > Access keys (Turkish)
export default Object.freeze({
	components: { accessKeyDeletionDialog },
	fallback: 'Hiç erişim anahtarınız yok',
	subtitle: 'Buradan erişim anahtarlarınızı yönetin',
	table: {
		fields: {
			actions: {
				label: 'Eylemler'
			},
			creationDate: {
				label: 'Oluşturulma tarihi'
			},
			creator: {
				label: 'Oluşturan'
			},
			expirationDate: {
				fallback: '∞',
				label: 'Son kullanma tarihi'
			},
			key: {
				label: 'Anahtar'
			},
			name: {
				fallback: 'İsimsiz',
				label: 'İsim'
			},
			type: {
				admin: 'Yönetici',
				label: 'Tür',
				member: 'Üye'
			}
		}
	},
	title: 'Takım erişim anahtarları'
})
